import { useLocale } from '@dreamstack/i18n'
import { getNewsTypeUrlPartReverse } from '../news/getNewsPath'
import { useParams } from './useParams'

export const useGetNewsTypeUrlPartReverse = () => {
  const locale = useLocale()
  const { newsTypeUrl } = useParams()
  return getNewsTypeUrlPartReverse({ locale, newsTypeUrl })
}
